
export const logJsonAndGoKeys = {
	id: "this.ID",
	logType: "this.LogType",
	timeStamp: "this.TimeStamp",
	dossierId: "this.DossierID",
	userId: "this.UserID",
	message: "this.Message",
	stack: "this.Stack"
} as any;
